import(/* webpackMode: "eager", webpackExports: ["ChokhEvent"] */ "/vercel/path0/components/chokh-event.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CoursePreviewBanner"] */ "/vercel/path0/components/course-preview-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IntentLink"] */ "/vercel/path0/components/layout/site-nav/IntentLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MermaidRenderer"] */ "/vercel/path0/components/mermaid-renderer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BelowFoldBands"] */ "/vercel/path0/components/showcase/BelowFoldBands.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RevealOnView"] */ "/vercel/path0/components/showcase/RevealOnView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CourseBottomCta"] */ "/vercel/path0/features/courses/components/CourseBottomCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CourseDesktopStickyEnrollPill"] */ "/vercel/path0/features/courses/components/CourseDesktopStickyEnrollPill.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CourseHeroPurchaseRow"] */ "/vercel/path0/features/courses/components/CourseHeroPurchaseRow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CourseHeroVideo"] */ "/vercel/path0/features/courses/components/CourseHeroVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CourseMobilePricingBar"] */ "/vercel/path0/features/courses/components/CourseMobilePricingBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CourseMultiPlanPricingSection"] */ "/vercel/path0/features/courses/components/CourseMultiPlanPricingSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CoursePreviewSync"] */ "/vercel/path0/features/courses/components/CoursePreviewSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CoursePricingBlock"] */ "/vercel/path0/features/courses/components/CoursePricingBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CoursePricingProvider"] */ "/vercel/path0/features/courses/components/CoursePricingProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CourseCurriculumGate"] */ "/vercel/path0/features/courses/components/detail/CourseCurriculumGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CoursePublicPinnedAnnouncement"] */ "/vercel/path0/features/courses/components/detail/CoursePublicPinnedAnnouncement.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhatYouWillLearnSection"] */ "/vercel/path0/features/courses/components/detail/WhatYouWillLearnSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CourseHubShellGate"] */ "/vercel/path0/features/courses/components/hub/CourseHubShellGate.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/katex/dist/katex.min.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/progsity-content.css");
